// Firebase client for global data tracking
import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getDatabase, Database } from 'firebase/database';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL as string,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string,
  appId: import.meta.env.VITE_FIREBASE_APP_ID as string,
};

// Initialize Firebase app
let app: FirebaseApp | null = null;
let database: Database | null = null;

if (firebaseConfig.apiKey && firebaseConfig.databaseURL) {
  try {
    const apps = getApps();
    app = apps.length > 0 ? apps[0] : initializeApp(firebaseConfig);
    database = getDatabase(app);
    
    if (typeof window !== 'undefined') {
      console.log('[Firebase] ✓ Client initialized successfully');
      console.log('[Firebase] Database URL:', firebaseConfig.databaseURL);
    }
  } catch (error: any) {
    console.error('[Firebase] Failed to initialize:', error.message);
  }
} else {
  if (typeof window !== 'undefined') {
    console.warn('[Firebase] ⚠ Client not initialized - missing credentials');
  }
}

export { app, database };

// Check if Firebase is configured
export const isFirebaseConfigured = (): boolean => {
  const isConfigured = !!firebaseConfig.apiKey && !!firebaseConfig.databaseURL && !!database;
  
  if (!isConfigured && typeof window !== 'undefined') {
    if (!firebaseConfig.apiKey || !firebaseConfig.databaseURL) {
      console.warn('[Firebase] Firebase is not configured. Missing VITE_FIREBASE_API_KEY or VITE_FIREBASE_DATABASE_URL environment variables.');
    }
  }
  
  return isConfigured;
};

// Test Firebase connectivity
export const testFirebaseConnection = async (): Promise<boolean> => {
  if (!isFirebaseConfigured() || !database) {
    console.warn('[Firebase] Connection test skipped - Firebase not configured');
    return false;
  }

  try {
    console.log('[Firebase] Testing connection...');
    
    const { get, ref } = await import('firebase/database');
    const visitsRef = ref(database, 'site_stats/total_visits');
    const snapshot = await get(visitsRef);
    
    const visits = snapshot.val() || 0;
    console.log('[Firebase] ✓ Connection test successful');
    console.log('[Firebase] Current visit count:', visits);
    return true;
  } catch (error: any) {
    console.error('[Firebase] ✗ Connection test error:', error.message);
    return false;
  }
};
